import React, {PropTypes} from 'react';


function MenuIcon(props) {
  const {
    className,
    isOpen,
    ...otherProps
  } = props;

  if (isOpen) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 20 22" className={`menu-icon ${className}`} {...otherProps}>
          <g fill="none" fillRule="evenodd" stroke="#FAFAFA" strokeWidth="2">
              <path strokeLinecap="round" d="M1 1v20"/>
              <path d="M3.742 10.943l4.51-2.704c.045-.026.1.006.1.058v5.406a.067.067 0 0 1-.1.058l-4.51-2.704a.067.067 0 0 1 0-.114z"/>
              <path strokeLinecap="round" d="M11.667 11H8.333"/>
          </g>
      </svg>
    );
  }
  else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 20 22"  className={`menu-icon ${className}`} {...otherProps}>
          <g fill="none" fillRule="evenodd" stroke="#FAFAFA" strokeWidth="2">
              <path strokeLinecap="round" d="M11.667 1v20"/>
              <path d="M8.925 10.943l-4.51-2.704a.066.066 0 0 0-.101.058v5.406c0 .052.057.084.1.058l4.51-2.704a.067.067 0 0 0 0-.114z"/>
              <path strokeLinecap="round" d="M1 11h3.333"/>
          </g>
      </svg>
    );
  }
}


MenuIcon.propTypes = {
  className: PropTypes.string
};

export default MenuIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/MenuIcon/index.js